import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1254.000000 1254.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1254.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M6085 10066 c-263 -43 -520 -163 -699 -327 -31 -28 -64 -65 -71 -80
-62 -119 104 -238 199 -142 14 14 60 51 101 83 197 148 425 223 680 223 293 1
524 -80 751 -263 95 -77 131 -90 187 -66 70 29 97 117 58 183 -55 89 -293 245
-486 318 -148 56 -265 77 -460 81 -118 2 -207 -1 -260 -10z"
          />
          <path
            d="M6110 9595 c-220 -45 -469 -197 -501 -305 -30 -100 86 -190 172 -132
14 9 55 39 90 66 262 201 652 190 909 -26 60 -50 67 -53 118 -53 48 0 57 3 83
33 24 26 29 41 29 82 0 58 -25 92 -123 166 -107 80 -241 138 -389 168 -94 19
-296 20 -388 1z"
          />
          <path
            d="M6182 9145 c-125 -29 -251 -106 -278 -171 -18 -43 -18 -68 1 -109 18
-36 51 -55 98 -55 31 0 43 6 123 62 54 38 152 61 217 53 69 -10 111 -28 172
-75 40 -31 61 -40 90 -40 108 0 160 117 87 197 -109 118 -333 179 -510 138z"
          />
          <path
            d="M6235 8733 c-68 -36 -97 -82 -97 -153 0 -193 279 -224 332 -37 37
129 -116 253 -235 190z"
          />
          <path
            d="M4505 8494 c-575 -36 -1123 -244 -1522 -577 -245 -205 -430 -440
-570 -724 -164 -331 -231 -653 -220 -1062 6 -214 17 -307 62 -496 47 -199 156
-462 262 -635 331 -536 901 -915 1558 -1035 684 -124 1389 31 1905 419 118 88
368 330 377 364 5 21 -31 60 -318 348 -235 235 -330 324 -347 324 -14 0 -58
-32 -119 -85 -212 -186 -441 -305 -693 -360 -103 -22 -365 -31 -471 -16 -397
56 -699 265 -869 601 -161 321 -190 733 -74 1077 174 519 656 835 1234 810
273 -13 495 -83 705 -223 44 -29 94 -66 111 -81 101 -90 143 -123 157 -123 24
0 727 703 727 727 0 22 -155 177 -270 270 -301 242 -682 398 -1125 457 -114
15 -394 26 -500 20z"
          />
          <path
            d="M6730 8403 c-113 -3 -127 -5 -142 -24 -17 -20 -18 -57 -18 -469 0
-436 0 -447 20 -465 20 -18 61 -19 838 -21 449 -1 841 -2 870 -3 l54 -1 -104
-97 c-56 -54 -152 -146 -213 -204 -60 -58 -211 -202 -335 -320 -124 -119 -257
-247 -297 -285 l-72 -69 -4 -323 c-3 -247 -1 -327 9 -340 11 -15 46 -17 386
-18 396 0 474 -7 648 -55 159 -44 314 -157 361 -264 70 -158 31 -345 -98 -465
-127 -119 -299 -174 -584 -187 -366 -16 -784 85 -1191 288 -75 38 -144 66
-152 63 -8 -3 -55 -101 -106 -217 -50 -117 -100 -230 -109 -252 -99 -223 -152
-357 -148 -370 4 -8 43 -33 89 -57 316 -161 573 -251 925 -322 476 -97 1044
-94 1459 9 197 48 279 77 439 155 292 141 512 352 629 601 61 131 84 203 108
343 17 102 19 147 15 286 -8 217 -40 356 -119 515 -161 323 -491 556 -923 650
-44 10 -93 21 -109 24 -28 6 -25 10 110 136 244 226 715 668 829 777 l110 105
3 386 c3 422 1 437 -54 473 -26 18 -100 18 -1513 19 -817 0 -1542 -1 -1611 -2z"
          />
          <path
            d="M4555 7366 c-5 -2 -50 -10 -100 -16 -49 -7 -115 -19 -145 -27 -30 -8
-59 -16 -65 -17 -28 -7 -95 -42 -95 -49 0 -5 8 -6 18 -3 220 65 291 77 465 76
137 0 323 -25 405 -54 24 -9 54 -17 67 -19 13 -1 27 -6 31 -10 10 -9 34 -9 34
1 -1 9 -90 52 -108 52 -7 0 -20 4 -30 9 -28 14 -87 31 -109 31 -11 0 -22 3
-26 6 -7 7 -47 11 -217 18 -63 3 -119 4 -125 2z"
          />
          <path
            d="M6631 7341 c-7 -5 -9 -11 -4 -14 15 -9 1440 -10 1454 -1 9 5 10 2 6
-10 -6 -15 -5 -15 17 1 l24 18 -47 7 c-69 10 -1434 9 -1450 -1z"
          />
          <path
            d="M4080 7230 c-8 -4 -30 -14 -47 -20 -28 -11 -46 -30 -28 -30 7 0 74
35 95 49 18 13 1 13 -20 1z"
          />
          <path
            d="M5185 7230 c3 -5 11 -10 17 -10 6 0 19 -7 28 -15 16 -14 80 -38 80
-30 0 2 -21 17 -47 34 -44 30 -91 42 -78 21z"
          />
          <path
            d="M7460 5687 c-57 -9 -89 -26 -54 -28 10 -1 174 -2 364 -3 l345 -1 173
-44 c106 -27 181 -51 195 -63 28 -25 77 -51 84 -45 5 6 -48 57 -60 57 -4 0
-26 11 -48 26 -45 28 -256 84 -317 84 -22 0 -64 5 -93 12 -64 14 -507 17 -589
5z"
          />
          <path
            d="M3164 4211 c7 -11 46 -35 46 -28 0 3 -12 12 -26 22 -15 9 -23 12 -20
6z"
          />
          <path
            d="M6435 4130 c8 -13 84 -50 102 -50 25 0 2 21 -44 41 -50 21 -67 24
-58 9z"
          />
          <path d="M5728 4113 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M3357 4099 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
          <path
            d="M9452 4090 c-32 -30 -27 -35 8 -10 17 12 30 23 30 26 0 10 -18 2 -38
-16z"
          />
          <path d="M3395 4080 c3 -5 14 -10 23 -10 15 0 15 2 2 10 -20 13 -33 13 -25 0z" />
          <path
            d="M6630 4037 c26 -25 110 -51 123 -38 8 8 6 11 -6 11 -10 0 -30 6 -45
14 -15 7 -40 16 -57 20 -26 6 -28 5 -15 -7z"
          />
          <path d="M5535 4030 c-19 -8 -19 -9 2 -9 12 -1 25 4 28 9 7 12 -2 12 -30 0z" />
          <path
            d="M3540 4020 c0 -10 31 -29 58 -35 21 -5 135 -43 182 -60 159 -60 750
-130 892 -105 29 5 91 11 138 15 47 3 92 8 100 10 8 3 44 9 80 14 148 22 320
64 309 75 -4 5 -50 -4 -149 -29 -282 -71 -806 -84 -1075 -28 -126 26 -199 42
-240 51 -52 11 -221 69 -256 88 -33 17 -39 17 -39 4z"
          />
          <path
            d="M9288 4008 c-15 -5 -49 -21 -75 -35 l-48 -25 37 7 c20 3 57 17 82 31
61 34 62 44 4 22z"
          />
          <path
            d="M5365 3967 c-33 -11 -53 -23 -44 -24 9 -2 45 7 80 21 78 30 48 33
-36 3z"
          />
          <path
            d="M6850 3955 c0 -13 168 -61 177 -51 11 11 -10 26 -36 26 -15 0 -36 7
-47 15 -18 13 -94 21 -94 10z"
          />
          <path
            d="M9061 3920 c-30 -11 -59 -24 -65 -30 -17 -17 24 -12 84 10 30 11 56
20 57 20 2 0 3 5 3 10 0 14 -17 12 -79 -10z"
          />
          <path d="M7128 3873 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M8913 3868 c-10 -3 -45 -11 -78 -18 -33 -6 -85 -18 -115 -26 l-55
-14 68 5 c37 3 79 10 93 15 14 6 37 10 52 11 15 0 45 9 67 19 35 15 37 17 13
16 -15 0 -35 -4 -45 -8z"
          />
          <path
            d="M7190 3861 c14 -7 58 -17 245 -56 139 -29 355 -55 435 -54 30 1 96
-2 145 -6 50 -3 137 -1 195 5 58 6 162 15 231 20 70 6 138 14 150 20 19 8 10
9 -36 5 -257 -23 -834 -14 -990 15 -27 5 -81 12 -119 15 -38 3 -103 14 -144
25 -78 21 -141 27 -112 11z"
          />
          <path
            d="M3830 3050 l0 -520 285 0 c329 0 393 9 520 70 387 186 387 715 1 899
-133 64 -184 71 -515 71 l-291 0 0 -520z m642 267 c166 -81 219 -284 116 -438
-63 -94 -160 -129 -360 -129 l-128 0 0 301 0 301 158 -4 c148 -3 160 -5 214
-31z"
          />
          <path
            d="M4243 3273 c-32 -3 -43 -8 -43 -21 0 -15 15 -17 118 -20 92 -2 114 0
105 9 -17 17 -83 39 -113 37 -14 -1 -44 -3 -67 -5z"
          />
          <path
            d="M5686 3513 c-24 -49 -140 -291 -348 -733 -72 -153 -108 -232 -108
-242 0 -5 62 -7 142 -6 l142 3 46 103 45 102 241 0 242 0 45 -102 45 -103 137
-3 c76 -1 143 2 148 7 5 5 0 26 -14 52 -12 24 -43 91 -69 149 -70 154 -155
341 -209 455 -26 55 -76 162 -112 237 l-64 138 -140 0 -141 0 -28 -57z m223
-348 c29 -66 61 -141 71 -167 l20 -48 -150 0 -149 0 24 53 c77 172 108 245
116 266 5 13 11 22 13 20 2 -2 27 -58 55 -124z"
          />
          <path
            d="M6680 3558 c0 -7 -2 -51 -3 -98 -2 -47 -1 -91 1 -97 3 -10 48 -13
178 -13 l174 0 2 -407 3 -408 135 0 135 0 3 407 2 408 178 2 177 3 0 105 0
105 -492 3 c-391 2 -493 0 -493 -10z"
          />
          <path
            d="M8291 3408 c-43 -90 -122 -253 -176 -363 -121 -249 -235 -494 -235
-506 0 -5 64 -9 143 -9 l142 1 45 102 46 102 242 3 242 2 10 -22 c5 -13 25
-59 44 -103 l35 -80 146 -3 c111 -2 145 0 145 10 0 12 -192 435 -383 843 l-84
180 -142 3 -142 3 -78 -163z m249 -190 c13 -35 41 -99 61 -143 20 -44 40 -90
43 -102 l7 -23 -145 0 c-80 0 -146 4 -146 9 0 4 27 68 61 142 34 74 65 144 70
157 5 12 12 22 16 22 5 0 19 -28 33 -62z"
          />
          <path
            d="M6758 3273 c-45 -5 -49 -19 -8 -28 49 -11 180 -2 180 13 0 6 -11 12
-24 12 -13 0 -43 2 -67 4 -24 2 -61 2 -81 -1z"
          />
          <path
            d="M7505 3270 c-71 -4 -100 -9 -99 -17 4 -46 4 -48 12 -35 10 15 125 35
161 27 15 -3 34 0 45 8 19 14 19 14 0 18 -10 2 -64 2 -119 -1z"
          />
          <path
            d="M5655 2639 c-7 -22 2 -39 13 -24 10 15 26 16 157 18 116 1 183 -5
205 -18 11 -7 13 14 2 31 -5 8 -66 12 -189 13 -175 1 -182 0 -188 -20z"
          />
          <path
            d="M8313 2643 c-8 -22 -2 -23 67 -13 58 9 112 8 263 -5 41 -4 47 -2 47
15 0 19 -8 20 -186 19 -150 -1 -187 -4 -191 -16z"
          />
          <path
            d="M4400 2454 c-49 -8 -153 -10 -297 -7 -135 2 -230 0 -240 -6 -35 -19
36 -24 305 -18 199 3 277 8 306 19 57 21 20 27 -74 12z"
          />
          <path
            d="M5272 2441 c-18 -11 42 -21 125 -21 60 0 89 12 57 24 -24 9 -167 7
-182 -3z"
          />
          <path
            d="M6247 2443 c-39 -10 -1 -23 68 -23 82 0 115 7 93 21 -13 9 -129 10
-161 2z"
          />
          <path
            d="M7096 2441 c-18 -7 -18 -8 -2 -14 25 -10 138 -8 154 2 10 6 8 10 -10
14 -31 9 -118 7 -142 -2z"
          />
          <path
            d="M7912 2443 c-32 -13 7 -23 86 -22 107 1 149 13 78 22 -55 8 -145 8
-164 0z"
          />
          <path
            d="M8872 2441 c-22 -14 11 -21 98 -21 43 0 86 3 95 6 34 13 -9 24 -95
24 -47 0 -91 -4 -98 -9z"
          />
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
